/**
 * @fileoverview POST handler for the "/integrations/direct/cdi/sources/:source_id/preview_and_validate" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postIntegrationsDirectCdiSourcesSourceIdPreviewAndValidateCacheKeys } from "./constants";
import type {
  PostIntegrationsDirectCdiSourcesSourceIdPreviewAndValidateProps,
  PostIntegrationsDirectCdiSourcesSourceIdPreviewAndValidateResult,
} from "./types";

export const postIntegrationsDirectCdiSourcesSourceIdPreviewAndValidate = reactQueryMutationAdapter(
  postIntegrationsDirectCdiSourcesSourceIdPreviewAndValidateCacheKeys,
  (
    props: PostIntegrationsDirectCdiSourcesSourceIdPreviewAndValidateProps
  ): Promise<PostIntegrationsDirectCdiSourcesSourceIdPreviewAndValidateResult> => {
    const {
      sourceId,
      sqlQuery,
      dataType,
      destination,
      composite_keys,
      big_query_table_name,
      limit,
      readerBehavior,
      table,
      mappingRules,
    } = props;
    const requestBody: Record<string, unknown> =
      readerBehavior === "visual_mapper"
        ? {
            data_type: dataType,
            reader_behavior: readerBehavior,
            table_name: table,
            data_map: { mapping_rules: mappingRules },
          }
        : { sql_query: sqlQuery, data_type: dataType };
    if (destination) {
      requestBody.destination = destination;
    }
    if (composite_keys?.length) {
      requestBody.composite_keys = composite_keys;
    }
    if (big_query_table_name) {
      requestBody.big_query_table_name = big_query_table_name;
    }
    if (limit != null) {
      requestBody.limit = limit;
    }
    return fetch(
      `/integrations/direct/cdi/sources/${sourceId}/preview_and_validate`,
      "POST",
      requestBody,
      undefined,
      { propagateFetchRequestError: false }
    );
  }
);
